module.exports = __webpack_public_path__ + "img/国广控股.5988dd99.png";